import { render } from "./VoiceRecord.vue?vue&type=template&id=263f457e&scoped=true"
import script from "./VoiceRecord.vue?vue&type=script&lang=js"
export * from "./VoiceRecord.vue?vue&type=script&lang=js"

import "./VoiceRecord.vue?vue&type=style&index=0&id=263f457e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263f457e"]])

export default __exports__